import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaviconProjectsActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9631 7V17.5417M17.9631 17.5417L27.831 23.5M17.9631 17.5417L7.91602 23.5",
			stroke: "#EAAFEF",
			strokeWidth: .916667
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M17.999 17.5L7.99902 12.5V24L17.999 29V17.5Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.91602 12.28L17.9993 7L28.0827 12.28M7.91602 12.28L17.9993 17.78M7.91602 12.28V23.5L17.9993 29M28.0827 12.28L17.9993 17.78M28.0827 12.28V23.72L17.9993 29M17.9993 17.78V29",
			stroke: "#C948D8"
		})
	]
});
export default SvgNaviconProjectsActive;
